module.exports = __webpack_public_path__ + "img/QSIM_title.40667fdf.png";